import React from 'react';
import MoreInfo from '../components/MoreInfo';

import StudiesIntroCard from '../components/StudiesIntroCard';

import microscopyImage1 from '../assets/img/micro_1.png';
import microscopyImage2 from '../assets/img/micro_2.png';

import graph1 from '../assets/img/graph_1.svg';
import graph2 from '../assets/img/graph_2.svg';

import graph_nitric from '../assets/img/graph_nitric.svg'

import '../styles/studies.css';

const Studies = () => {
    return (
        <div className='studies'>
            <div className='studies-intro'>
                <h1 className='studies-intro-title'>
                    Scanning<br /> electron <br /> microscopy<br />  <span className='studies-intro-title-notBold'>(SEM)</span> and<br />  Transmission<br /> electron<br /> microscopy <span className='studies-intro-title-notBold'>(TEM)</span>
                </h1>
                <StudiesIntroCard
                    img={microscopyImage1}
                    title={"The morphological structure<br/> of Testolift was examined by<br/> SEM as shown in Fig 1 "}
                    legend={"Fig 1. SEM Image of Testolift."}
                    type={1}
                />
                <StudiesIntroCard
                    img={microscopyImage2}
                    title={"The morphological structure<br/> of Testolift was examined by<br/> TEM as shown in Fig 2 "}
                    legend={"Fig 2. TEM Image of Testolift"}
                    type={2}
                />
            </div>
            <div className='studies-content'>
                <div className='studies-content-text'>
                    <h2 className='studies-content-text-title'>
                        <span className='studies-content-text-title-color'>
                            zeta potential
                        </span> <br />
                        and particle size <br /> distribution
                    </h2>
                    <p className='studies-content-text-description'>
                        Testolift  delivers advanced performance with a finely tuned particle size range of 120-260 nm, with a mean
                        particle size of 193 nm, and consistently uniform, well-dispersed particles for optimal bioavailability.
                    </p>
                    <p className='studies-content-text-description'>
                        The zeta potential value showed -32.24mV, which shows the stability of nano suspension
                    </p>
                </div>
                <div className='studies-content-graphs-wrapper'>
                    <div className='studies-content-graphs'>
                        <img className='studies-content-graph' src={graph1} alt="Graph 1" />
                        <img className='studies-content-graph' src={graph2} alt="Graph 2" />
                    </div>
                    <p className='studies-content-graphs-legend'>Fig 3. Zeta potential (a) and particle size distribution (b) of the Testolift.</p>
                </div>
            </div>
            <div className='studies-nitric'>
                <div className='studies-nitric-text'>
                    <h1 className='studies-nitric-title'>Nitric<br />oxide<br /><span className='color'>inhibition</span></h1>
                    <p className='studies-nitric-description'><span className='color'>Testolift</span> exhibited the strongest inhibition <br /> of LPS-induced NO production in RAW <br /> 264.7 cells, with a maximum inhibition of <br />67.02% at 100 µg/mL.</p>
                    <p className='studies-nitric-description'><span className='color'>Black ginger and fenugreek</span> showed<br />moderate inhibition, reaching 61.03% and<br />58.01%, respectively (Fig. 4), in a<br />concentration-dependent manner. </p>
                </div>
                <div className='studies-nitric-graph'>
                    <img className='studies-nitric-graph-img' src={graph_nitric} alt="Nitric oxide inhibition graph" />
                    <p className='studies-nitric-graph-legend'>Fig 4. Percentage of nitric oxide inhibition<br /> of Testolift, blank ginger extract and<br /> Fenugreek extract at 100 µg/mL.</p>
                </div>
                <div className='studies-nitric-conclusion'>
                    <p className='studies-nitric-conclusion-text'>These results indicate that<br /> Testolift exhibit synergistic<br /> effects that enhance its overall<br /> anti inflammatory effects</p>
                </div>
            </div>
            <div className='studies-benefits'>
                <div className='studies-benefits-row'>
                    <div className='studies-benefits-col col-1'>
                        <h3 className='studies-benefits-title color'>anti-inflammatory <br />activity</h3>
                        <p className='studies-benefits-description'>
                            The significant inhibition of nitric oxide production by Testolift aligns with their known anti-inflammatory properties.
                            <br /> <br />
                            Black ginger (Kaempferia parviflora) has been reported to suppress the expression of pro-inflammatory cytokines such as IL-6 and TNF-α in muscle tissue, contributing to reduced inflammation and improved muscle function.
                        </p>
                    </div>
                    <div className='studies-benefits-col col-2'>
                        <h3 className='studies-benefits-title color'>testosterone <br />enhancement</h3>
                        <p className='studies-benefits-description'>
                            Fenugreek (Trigonella foenum-graecum) has demonstrated the ability to increase testosterone levels in men.
                            <br /> <br />
                            A meta-analysis of clinical trials found that fenugreek extract supplementation significantly increased serum total testosterone levels.
                            <br/> <br />
                            This effect is attributed to the presence of saponins and sapogenins, such as diosgenin, which have anabolic and androgenic activities.
                        </p>
                    </div>
                </div>
                <div className='studies-benefits-row'>
                    <div className='studies-benefits-col col-3'>
                        <h3 className='studies-benefits-title color'>muscle <br /> performance <br /> and endurance</h3>
                        <p className='studies-benefits-description'>
                            Both black ginger and fenugreek have been associated with improved muscle performance and endurance.
                            <br/>  <br />
                            Black ginger extract has been shown to enhance physical fitness performance and muscular endurance by reducing inflammation, improving energy metabolism, increased mitochondrial biogenesis and glycogen content in muscle tissues.
                            <br/> <br />
                            Fenugreek supplementation has been linked to increased muscle strength, lean body mass, and reduced body fat in resistance-trained males.
                        </p>
                    </div>
                    <div className='studies-benefits-col col-4'>
                        <h3 className='studies-benefits-title color'>synergistic<br /> effects <br /> of testolift</h3>
                        <p className='studies-benefits-description'>
                            The anti-inflammatory properties of black ginger, coupled with the testosterone-enhancing effects of fenugreek, could collectively contribute to improved muscle function, endurance, and overall physical performance.
                        </p>
                    </div>
                </div>
            </div>
            <MoreInfo />
        </div>
    );
};

export default Studies;